import { memo } from "react";
import Grid from "@mui/material/Grid";
import QuantityInput from "../../../common/QuantityInput";
import {
  maxLength,
  minLength,
  minValue,
  number,
  TextInput,
  useDataProvider,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import SaleOrderItemReference from "../../../common/SaleOrderItemReference";
import BonusProductFromSaleOrderReference from "../../../common/BonusProductFromSaleOrderReference";
import {
  inputTextProduct,
  matchSuggestionProduct,
  OptionRendererProduct,
} from "../../../../common/OptionRendererProduct";

const equalOrLessThan = (value, allValues, elm) => {
  const splite = elm.source.split(".");
  const orderQty = allValues[splite[0]][+splite[1]].quantity;
  if (value > orderQty) {
    return "Must be equal or less than " + orderQty + " (order quantity)";
  }
  return undefined;
};

const validateSaleOrderItemId = [minLength(36), maxLength(36)];
const validateQuantity = [number(), minValue(1), equalOrLessThan];
const validateCode = [maxLength(50)];

const CstInput = ({
  code,
  quantity,
  // NAMA-NAMA SOURCE
  saleOrderItemIdSource,
  bonusProductIdSource,
  sentQuantitySource,
  nameSource,
  formData,
  ...props
}) => {
  const { setValue } = useFormContext();

  const dataProvider = useDataProvider();

  const onSaleOrderItemIdChangeHandler = async (uuid) => {
    // setValue(sentQuantitySource, "");
    // if (uuid.length !== 36) {
    //   setValue(nameSource, "");
    // }
    // if (uuid) {
    //   try {
    //     const { product, quantity, price } =
    //       // see: https://stackoverflow.com/a/332888
    //       await dataProvider.getListNoParams(
    //         "sale-order-items/" + encodeURIComponent(uuid)
    //       );
    //     setValue(nameSource, product.name);
    //   } catch (error) {}
    // }
  };

  const onBonusProductChangeHandler = async (productId) => {
    setValue(nameSource, "");
    if (!productId || productId.length !== 36) {
      return;
    }
    
    // Cari nama produk dari form data atau dari sale order items
    const saleOrderId = formData.sale_order_id;
    if (!saleOrderId) return;
    
    try {
      // Ambil data sale order items untuk mendapatkan nama produk
      const { data } = await dataProvider.getList("sale-order-items", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
        filter: { sale_order_id: saleOrderId },
      });
      
      const selectedItem = data.find(item => item.product_id === productId);
      if (selectedItem && selectedItem.name) {
        setValue(nameSource, selectedItem.name);
      }
    } catch (error) {
      console.error("Error fetching bonus product name:", error);
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        // "& .MuiGrid-item:not(:first-of-type)": { pt: 0 },
        "& .MuiGrid-item": { py: 0 },
        mt: 0,
      }}
    >
      <Grid item xs={12} lg={2}>
        <SaleOrderItemReference
          variant="outlined"
          source={saleOrderItemIdSource}
          fullWidth
          label="mine.label.main_product"
          validate={validateSaleOrderItemId}
          dependOn="sale_order_id"
          queryName="sale_order_id"
          reference="sale-order-items"
          onChange={onSaleOrderItemIdChangeHandler}
          helperText={false}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <BonusProductFromSaleOrderReference
          fullWidth
          source={bonusProductIdSource}
          variant="outlined"
          label="mine.label.product_bonus"
          onChange={onBonusProductChangeHandler}
          dependOn="sale_order_id"
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} lg={5}>
        <TextInput
          variant="outlined"
          source={nameSource}
          label="mine.label.name"
          disabled
          fullWidth
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} lg={1}>
        <QuantityInput
          variant="outlined"
          source={sentQuantitySource}
          label="mine.label.sent"
          fullWidth
          validate={validateQuantity}
          helperText={false}
        />
      </Grid>
    </Grid>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (prevProps.sale_order_item_id === nextProps.sale_order_item_id) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};
const Beruk = memo(CstInput, propsAreEqual);

const Inputs = ({
  formData, // The whole form data
  scopedFormData, // The data for this item of the ArrayInput
  getSource, // A function to get the valid source inside an ArrayInput
  ...rest
}) => {
  return (
    <CstInput
      {...scopedFormData}
      formData={formData}
      saleOrderItemIdSource={getSource("sale_order_item_id")}
      bonusProductIdSource={getSource("bonus_product_id")}
      sentQuantitySource={getSource("sent_quantity")}
      nameSource={getSource("name")}
    />
  );
};
export default Inputs;
